<template>
    <div class="view view--change-password">
        <change-password />
    </div>
</template>

<script>
    import changePassword from '../../components/ChangePassword.vue';

    export default {
        components: {
            changePassword
        }
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/views/auth/ChangePassword.vue